import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { FunctionVersionsByCapacityProviderListItem } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../magic/MagicTable';

export type LambdaCapacityProviderVersionsTableProps = {
  loading?: boolean;
  selectable?: boolean;
  data: FunctionVersionsByCapacityProviderListItem[];
  onSelect?: (names: string[]) => void;
  onView?: (name: string) => void;
};

export const LambdaCapacityProviderVersionsTable = ({
  loading,
  selectable = true,
  data,
  onSelect,
  onView,
}: LambdaCapacityProviderVersionsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('Lambda')}
    entry="FunctionVersionsByCapacityProviderListItem"
    idAttribute="FunctionArn"
    order={['FunctionArn']}
    rows={data}
    selectable={selectable}
    onSelect={onSelect}
    loading={loading}
    externalFields={{
      FunctionArn: (row) => (
        <Link onClick={() => onView && onView(row.FunctionArn as string)} underline="hover">
          {row.FunctionArn}
        </Link>
      ),
    }}
  />
);
